import AppForm from "../app-components/Form/AppForm";
import {cloneDeep} from 'lodash';

var _moment = require('moment');

var userLanguage = document.documentElement.lang;

//form for creating only
Vue.component('form-employee-with-contract', {
    mixins: [AppForm],
    props: {
        'mymcdSync': {
            //type: Array,
            required: true,
            default: function(){
                return false;
            },
        },
    },
    data: function() {
        return {
            form: {

            },
            tabsErrors: {
                employeeForm: false,
                contractForm: false,
                addressesForm: false,
                attendanceForm: false,
                mymcdForm: false
            },
            hasRangeError: null,
            // server errors the form has no input for (e.g. dynamicFieldsValues, contracts.0.* when no contract was sent)
            unplacedServerErrors: [],
            mutableMymcdSync: this.mymcdSync,
            tabsErrorsSyncInterval: null,
            initialTab: (function() {
                const savedIndex = localStorage.getItem('editEmployeeSelectedTab');
                return savedIndex !== null ? parseInt(savedIndex) : 3;
            })(),
        }
    },

    mounted() {
        this.syncTabsErrorsFromValidators();
        this.tabsErrorsSyncInterval = setInterval(() => {
            this.syncTabsErrorsFromValidators();
        }, 250);
    },

    beforeDestroy() {
        if (this.tabsErrorsSyncInterval) {
            clearInterval(this.tabsErrorsSyncInterval);
            this.tabsErrorsSyncInterval = null;
        }
    },

    methods: {
        hasTabValidationError(refName) {
            const ref = this.$refs[refName];

            if (!ref || !ref.$el || !ref.$el.querySelector) {
                return false;
            }

            // invalid inputs of the visible contract / quarter and error badges of the other contracts / quarters
            return !!ref.$el.querySelector('.form-control-danger, .has-danger, .item-validation-badge.badge-danger, .list-group-item-danger');
        },

        syncTabsErrorsFromValidators() {
            this.tabsErrors.employeeForm = this.hasTabValidationError('employee_form');
            this.tabsErrors.addressesForm = this.hasTabValidationError('permanent_address_form') || this.hasTabValidationError('temporary_address_form');
            this.tabsErrors.attendanceForm = this.hasTabValidationError('attendance_form');
            this.tabsErrors.contractForm = this.hasTabValidationError('contract_form');
        },

        preventSubmit(event) {
            if (event) event.preventDefault();
            if (event) event.stopPropagation();
        },

        getPostData() {

            const employeeForm = this.$refs.employee_form.getPostData();
            const contractsPostdata = this.$refs.contract_form.getPostData();
            const permanentAddressForm = this.$refs.permanent_address_form.getData();
            const temporaryAddressForm = this.$refs.temporary_address_form.getData();
            const attendanceForm = this.$refs.attendance_form.getData();
            const mymcdForm = this.$refs.mymcd_form ? this.$refs.mymcd_form.getData() : null;

            employeeForm.contracts = contractsPostdata;
            employeeForm.permanent_address = permanentAddressForm;
            employeeForm.temporary_address = temporaryAddressForm;
            employeeForm.attendance_data = attendanceForm;

            if(mymcdForm !== null) {
                employeeForm.mymcd_sync = mymcdForm.mymcd_sync
            }

            return employeeForm;
        },

        onSubmit(submitType) {
            this.submiting = true;
            this.hasRangeError = null;

            return Promise.all([
                       this.$refs.employee_form.$validator.validateAll(),
                       this.$refs.contract_form.validatorValidateAllContracts(),
                       this.$refs.permanent_address_form.$validator.validateAll(),
                       this.$refs.temporary_address_form.$validator.validateAll(),
                       this.$refs.attendance_form.$validator.validateAll()
                   ]).then((responseArr) => {
                       if(responseArr[0] === false){
                            console.log("validation errors [employee_form]: ", this.$refs.employee_form.$validator.errors);
                       }
                       if(responseArr[1] === false){
                            console.log("validation errors [contract_form]: ", this.$refs.contract_form.$validator.errors);
                       }

                       if (responseArr.includes(false)) {
                            this.tabsErrors.employeeForm = !responseArr[0];
                            this.tabsErrors.contractForm = !responseArr[1];
                            this.tabsErrors.addressesForm = (!responseArr[2] || !responseArr[3]);
                            this.tabsErrors.attendanceForm = !responseArr[4];

                            this.$notify({ type: 'error', title: this.trans.errors.title, text: this.trans.errors.form_contains_errors });
                            this.submiting = false;
                            return false;
                       } else {
                            this.clearServerErrors();

                            const postData = this.getPostData();
                            // server errors are matched to the values that were sent
                            const submittedData = cloneDeep(postData);

                            axios.post(this.action, postData).then((response) => {
                                return this.onSuccess(response.data, submitType);
                            }).catch((error) => {
                                if (error.response && error.response.status === 422 && error.response.data.errors) {
                                    return this.onFail(error.response.data.errors, submittedData);
                                }
                                this.$notify({ type: 'error', title: this.trans.errors.title, text: this.trans.errors.server_error });
                            }).finally(() => {
                                this.submiting = false;
                            });
                            return true;
                       }
                    });
        },

        onSuccess(data, submitType) {
            this.submiting = false;

            this.$notify({ type: 'success', title: '<span class="fa fa-check"></span>', text: data.message });

           if(submitType == 'save' && this.action != "add") {
                window.location.reload();
            } else if(submitType == 'save_close' && this.action == "add") {
                window.location.href = data.redirect_default;
            } else {
                window.location.href = data.redirect;
            }
        },

        clearServerErrors() {
            this.unplacedServerErrors = [];
            this.$refs.contract_form.clearServerFieldErrors();
            this.$refs.attendance_form.clearServerErrors();
        },

        // shows every server validation error at its input (in its own sub-form), or in the alert above the form
        onFail: function onFail(errors, submittedData) {
            this.submiting = false;

            const employeeForm = this.$refs.employee_form;
            const addressForms = {
                permanent_address: this.$refs.permanent_address_form,
                temporary_address: this.$refs.temporary_address_form,
            };
            // server key -> input name, where they differ
            const employeeFieldNames = {
                'phone_number.code': 'phone_code',
                'phone_number.number': 'phone',
            };
            const contractErrors = [];
            const attendanceErrors = [];

            employeeForm.$validator.errors.clear();

            Object.keys(errors).forEach((key) => {
                const msg = errors[key][0];
                let match;

                if ((match = key.match(/^contracts\.(\d+)\.(.+)$/)) && submittedData.contracts[match[1]]) {
                    contractErrors.push({ contract: submittedData.contracts[match[1]], field: match[2], msg: msg });
                } else if ((match = key.match(/^attendance_data\.(\d+)\.avgHourSalary$/)) && submittedData.attendance_data[match[1]]) {
                    attendanceErrors.push({ quarter: submittedData.attendance_data[match[1]], msg: msg });
                } else if ((match = key.match(/^(permanent_address|temporary_address)\.(.+)$/)) && addressForms[match[1]].fields[match[2]]) {
                    addressForms[match[1]].$validator.errors.add({ field: match[2], msg: msg });
                } else {
                    const field = [key, key.replace(/^personal_data\./, ''), employeeFieldNames[key]]
                        .find(name => name && employeeForm.fields[name]);

                    if (field) {
                        employeeForm.$validator.errors.add({ field: field, msg: msg });
                    } else {
                        this.unplacedServerErrors.push(msg);
                    }
                }
            });

            this.$refs.contract_form.setServerFieldErrors(contractErrors);
            this.$refs.attendance_form.setServerErrors(attendanceErrors);

            this.$notify({ type: 'error', title: this.trans.errors.title, text: this.trans.errors.form_contains_errors });
        },

        closeWindow(event) {
            if(history.previous || history.length > 1) {
                event.preventDefault();
                history.go(-1);
            }
            else if(window.opener){
                event.preventDefault();
                window.close();
            }
        },

        showDisableSyncEmployeeModal() {
            this.$modal.show('disable-sync-employee-modal');
        },

        updateMymcdSync(newValue) {
            this.mutableMymcdSync = newValue;
        },

        saveSelectedTab(index) {
            localStorage.setItem('editEmployeeSelectedTab', index);
        },
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/FormEmployeeWithContract.js